import { Settings as SettingsIcon } from "lucide-react";

export const Settings = () => {
    const settingsItems = [
        "System",
        "Bluetooth",
        "Network",
        "Personalization",
        "Apps",
        "Accounts",
        "Time & Language",
        "Gaming",
        "Accessibility",
    ];

    return (
        <div className="w-full h-full bg-gray-100 p-4">
            <div className="grid grid-cols-3 gap-4">
                {settingsItems.map((item) => (
                    <div key={item} className="bg-white p-4 rounded-lg shadow hover:bg-gray-50 cursor-pointer flex items-center">
                        <SettingsIcon className="w-6 h-6 mr-2 text-blue-500" />
                        <span>{item}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};
